import { render, staticRenderFns } from "./StreakPage.vue?vue&type=template&id=1961a11f"
import script from "./StreakPage.vue?vue&type=script&lang=js"
export * from "./StreakPage.vue?vue&type=script&lang=js"
import style0 from "./StreakPage.vue?vue&type=style&index=0&id=1961a11f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports